import $ from "jquery";
import Notices from "./Notices";
import AjaxBlocking from "./AjaxBlocking";

export default class MyAccountComplaint {
    constructor() {
        this.makeReclamationBtns = document.querySelector(".jsMakeReclamation");
        this.reclamationProducts = document.querySelector(
            ".jsReclamationProducts"
        );
        this.reclamationProductsItem = document.querySelector(
            ".jsReclamationProductsItem"
        );
        this.reclamationProductsAddBtn = document.querySelector(
            ".jsReclamationProducts__add"
        );
        this.reclamationProductsDeleteBtn = document.querySelector(
            ".jsReclamationProducts__delete"
        );
        this.reclamationType = document.querySelector(".jsReclamationType");
        this.reclamationDateCreated = document.querySelector(
            ".jsReclamationDateCreated"
        );
        this.reclamationTimeCreated = document.querySelector(
            ".jsReclamationTimeCreated"
        );
        this.reclamationCreatorName = document.querySelector(
            ".jsReclamationCreatorName"
        );
        this.reclamationNotes = document.querySelector(".jsReclamationNotes");
        this.reclamationBankwire = document.querySelector(
            ".jsReclamationBankwire"
        );
        this.makeReclamationFileInput = document.getElementById("file");
        this.reclamationFiles = "";

        this.complaintCheckboxes = [
            ...document.querySelectorAll(".jsComplaintCheckbox"),
        ];
        this.quantityInputs = [
            ...document.querySelectorAll(".jsComplaintQuantity"),
        ];

        this.complaintForm = document.querySelector(".jsComplaintForm");

        this.complaintReason = "";
        this.complaintErrors = {};
        this.submitAllowed = false;

        this.complaintErrorsContainer = document.querySelector(
            ".jsComplaintErrorsContainer"
        );

        this.complaintProductsContent = document.querySelector(
            ".jsComplaintProductsContent"
        );

        this.complaintHeading = document.querySelector(".jsComplaintHeading");

        if (this.makeReclamationBtns) {
            this.events();
        }
    }

    events() {
        window.addEventListener("DOMContentLoaded", () => {
            this.initializeSelectField();
        });

        const self = this;
        this.makeReclamationBtns.addEventListener("click", function (e) {
            e.preventDefault();
            const inputItems = {
                reclamationType: self.reclamationType,
                reclamationDateCreated: self.reclamationDateCreated,
                reclamationTimeCreated: self.reclamationTimeCreated,
                reclamationCreatorName: self.reclamationCreatorName,
                reclamationNotes: self.reclamationNotes,
                reclamationBankwire: self.reclamationBankwire,
            };

            if (this.dataset.isLogged) {
                inputItems.reclamationItems = self.getProducts(); // pobieranie produktów z checkboxów - tablica obiektów
            } else {
                inputItems.reclamationItems = self.getProductsArray(
                    document.querySelectorAll(".jsReclamationProductsItem")
                );
            }

            const reason = self.getReason();

            self.handleSubmitErrors(inputItems, self.reclamationFiles, reason);

            if (!self.submitAllowed) return;

            self.makeReclamation(this, inputItems, self.reclamationFiles);
        });

        if (
            this.reclamationProductsAddBtn &&
            this.reclamationProductsDeleteBtn
        ) {
            this.reclamationProductsAddBtn.addEventListener(
                "click",
                function (e) {
                    e.preventDefault();
                    const clone = self.reclamationProductsItem.cloneNode(true);
                    const cloneInputName = clone.querySelector(
                        ".jsReclamationProductsItem__name"
                    );
                    const cloneInputNameLabel = cloneInputName.placeholder;

                    const cloneInputQuantity = clone.querySelector(
                        ".jsReclamationProductsItem__quantity"
                    );
                    const cloneInputQuantityLabel =
                        cloneInputQuantity.placeholder;

                    clone.innerHTML = "";

                    // Product name input markup
                    const nameControl = document.createElement("div");
                    nameControl.classList.add(
                        "form__control",
                        "reclamation__products__item__name"
                    );

                    const nameWrap = document.createElement("p");
                    nameWrap.classList.add("form-control-wrap");
                    nameControl.appendChild(nameWrap);

                    const inputName = document.createElement("input");
                    inputName.type = "text";
                    inputName.classList.add(
                        "jsReclamationProductsItem__name",
                        "form__input"
                    );
                    inputName.setAttribute("aria-label", cloneInputNameLabel);
                    inputName.setAttribute("placeholder", cloneInputNameLabel);
                    nameWrap.appendChild(inputName);

                    clone.appendChild(nameControl);

                    // Product quantity input markup
                    const quantityControl = document.createElement("div");
                    quantityControl.classList.add(
                        "form__control",
                        "reclamation__products__item__quantity"
                    );

                    const quantityWrap = document.createElement("p");
                    quantityWrap.classList.add("form-control-wrap");
                    quantityControl.appendChild(quantityWrap);

                    const inputQuantity = document.createElement("input");
                    inputQuantity.type = "number";
                    inputQuantity.classList.add(
                        "jsReclamationProductsItem__quantity",
                        "form__input"
                    );
                    inputQuantity.setAttribute(
                        "aria-label",
                        cloneInputQuantityLabel
                    );
                    inputQuantity.setAttribute(
                        "placeholder",
                        cloneInputQuantityLabel
                    );
                    quantityWrap.appendChild(inputQuantity);

                    clone.appendChild(quantityControl);

                    self.reclamationProducts.append(clone);
                }
            );

            this.reclamationProductsDeleteBtn.addEventListener(
                "click",
                function (e) {
                    e.preventDefault();
                    self.reclamationProducts.removeChild(
                        self.reclamationProducts.lastChild
                    );
                }
            );
        }

        this.makeReclamationFileInput.addEventListener("change", function (e) {
            if (this.files.length > 0) {
                self.reclamationFiles = this.files;
            }
        });

        if (this.quantityInputs.length) {
            this.quantityInputs.forEach((input) =>
                input.addEventListener("change", (e) => {
                    this.validateQuantityInput(e.currentTarget);
                })
            );
        }
    }

    initializeSelectField() {
        const select = this.reclamationType;

        $(select).select2({
            placeholder: select.dataset.placeholderText,
            minimumResultsForSearch: -1,
        });
    }

    filterCheckedCheckboxes() {
        return this.complaintCheckboxes.filter((checkbox) => checkbox.checked);
    }

    validateQuantityInput(input) {
        let quantity;

        const currentValue = parseInt(input.value, 10);
        const minVal = parseInt(input.min, 10);
        const maxVal = parseInt(input.max, 10);

        if (currentValue < minVal) {
            quantity = minVal;
        } else if (currentValue > maxVal) {
            quantity = maxVal;
        } else {
            quantity = currentValue;
        }

        input.value = quantity;
    }

    getSelectedItems(checkboxes) {
        const selectedItems = [];

        if (checkboxes.length) {
            checkboxes.forEach((checkbox) =>
                selectedItems.push(checkbox.closest(".jsComplaintItem"))
            );
        }

        return selectedItems;
    }

    getItemsWithQuantity(items) {
        const products = [];

        if (items.length) {
            items.forEach((item) => {
                const input = item.querySelector(".jsComplaintQuantity");
                this.validateQuantityInput(input);

                const quantity = parseInt(input.value, 10);

                if (quantity > 0) {
                    const product = {
                        productId: parseInt(item.dataset.productId, 10),
                        productName: item.dataset.productName,
                        quantity: quantity,
                    };
                    products.push(product);
                }
            });
        }

        return products;
    }

    getProducts() {
        const selectedChekboxes = this.filterCheckedCheckboxes();
        const selectedItems = this.getSelectedItems(selectedChekboxes);
        const selectedProducts = this.getItemsWithQuantity(selectedItems);

        return selectedProducts;
    }

    makeReclamation(item, inputItems, files) {
        let formData = new FormData();
        formData.append("action", "makeReclamation");
        formData.append("orderId", item.dataset.orderId);
        formData.append("reclamationType", inputItems.reclamationType.value); // Z - niezgodność zamówienia, S - gwarancyjna
        formData.append(
            "reclamationDateCreated",
            inputItems.reclamationDateCreated.value
        ); // data przygotowania zamówienia
        formData.append(
            "reclamationTimeCreated",
            inputItems.reclamationTimeCreated.value
        ); // godzina przygotowania zamówienia
        formData.append(
            "reclamationCreatorName",
            inputItems.reclamationCreatorName.value
        ); // imie i nazwisko osoby przygotowujacej zamowienie
        formData.append(
            "reclamationProducts",
            JSON.stringify(inputItems.reclamationItems)
        ); // produkty
        formData.append("reclamationNotes", inputItems.reclamationNotes.value); // komentarz
        formData.append(
            "reclamationBankwire",
            inputItems.reclamationBankwire.value
        ); // nr konta bankowego

        if (files.length > 0) {
            for (const file of files) {
                formData.append("attachment[]", file);
            }
        }

        const self = this;

        $.ajax({
            // eslint-disable-next-line no-undef
            url: ajax.ajaxurl,
            type: "POST",
            data: formData,
            contentType: false,
            processData: false,
            beforeSend: function () {
                self.makeReclamationBtns.disabled = true;
                self.makeReclamationBtns.classList.add("is-sending");
                self.blockForAjax();
            },
            success: function (response) {
                if (response) {
                    console.log("Utworzono zwrot");
                    self.makeReclamationBtns.classList.remove("is-sending");
                    self.makeReclamationBtns.classList.add("is-success");
                    self.handleAjaxSuccess();
                    formData = {};

                    self.unblockForAjax();
                    // eslint-disable-next-line no-unused-vars
                    const complaintNotices = new Notices(true);
                }
            },
            error: function (request) {
                console.log(request.responseText);
                self.makeReclamationBtns.classList.remove("is-sending");
                self.makeReclamationBtns.disabled = false;

                self.unblockForAjax();
            },
        });
    }

    getProductsArray(items) {
        const products = [];

        if (items.length > 0) {
            for (const item of items) {
                products.push({
                    productId: "",
                    productName: item.children[0].value,
                    quantity: item.children[1].value,
                });
            }
        }

        return products;
    }

    getReason() {
        const select = this.reclamationType;
        const info = $(select).select2("data")[0].text;

        return info;
    }

    showComplaintErrors(errors, container) {
        let errorsHTML = "";

        for (const error in errors) {
            errorsHTML += `<p>${errors[error]}</p>`;
        }

        container.innerHTML = errorsHTML;
        container.classList.add("is-active");
    }

    handleSubmitErrors(inputs, files, reason) {
        if (!inputs.reclamationItems.length) {
            this.complaintErrors.errorProducts =
                this.complaintErrorsContainer.dataset.errorProducts;
        } else {
            delete this.complaintErrors.errorProducts;
        }

        if (!reason.length) {
            this.complaintErrors.errorSelect =
                this.complaintErrorsContainer.dataset.errorSelect;
        } else {
            delete this.complaintErrors.errorSelect;
        }

        if (!inputs.reclamationDateCreated.value) {
            this.complaintErrors.errorDateCreated =
                this.complaintErrorsContainer.dataset.errorDateCreated;
        } else {
            delete this.complaintErrors.errorDateCreated;
        }

        if (!inputs.reclamationTimeCreated.value) {
            this.complaintErrors.errorTimeCreated =
                this.complaintErrorsContainer.dataset.errorTimeCreated;
        } else {
            delete this.complaintErrors.errorTimeCreated;
        }

        if (!inputs.reclamationCreatorName.value) {
            this.complaintErrors.errorCreatorName =
                this.complaintErrorsContainer.dataset.errorCreatorName;
        } else {
            delete this.complaintErrors.errorCreatorName;
        }

        if (
            !inputs.reclamationBankwire.value ||
            inputs.reclamationBankwire.value.length !== 26
        ) {
            this.complaintErrors.errorBankwire =
                this.complaintErrorsContainer.dataset.errorBankwire;
        } else {
            delete this.complaintErrors.errorBankwire;
        }

        if (!Object.keys(files).length) {
            this.complaintErrors.errorFiles =
                this.complaintErrorsContainer.dataset.errorFiles;
        } else {
            delete this.complaintErrors.errorFiles;
        }

        if (Object.keys(this.complaintErrors).length) {
            this.submitAllowed = false;
            this.showComplaintErrors(
                this.complaintErrors,
                this.complaintErrorsContainer
            );
        } else {
            this.complaintErrorsContainer.classList.remove("is-active");
            this.complaintErrorsContainer.innerHTML = "";
            this.submitAllowed = true;
        }
    }

    handleAjaxSuccess() {
        const successMessage =
            this.complaintProductsContent.dataset.complaintSuccess;
        const btnUrl = this.complaintProductsContent.dataset.buttonUrl;
        const btnText = this.complaintProductsContent.dataset.buttonText;

        const successHTML = `
            <p class="my-account__return-products__success-msg">${successMessage}</p>
            <a class="btn btn--black return-products__btn-success" href="${btnUrl}">${btnText}</a>
        `;

        this.complaintProductsContent.innerHTML = successHTML;
        this.complaintForm.innerHTML = "";
        this.complaintHeading.innerHTML = "";
    }

    handleAjaxError() {
        this.complaintErrors.returnError =
            this.complaintErrorsContainer.dataset.returnError;
        this.showReturnErrors(
            this.complaintErrors,
            this.complaintErrorsContainer
        );

        setTimeout(() => {
            delete this.complaintErrors.returnError;
            this.complaintErrorsContainer.innerHTML = "";
            this.complaintErrorsContainer.classList.remove("is-active");
        }, 4000);
    }

    blockForAjax() {
        if (!this.complaintForm) return;

        const section = this.complaintForm.closest(
            ".woocommerce-MyAccount-content"
        );

        console.log(section);

        if (!section) return;

        const myBlock = new AjaxBlocking();
        myBlock.blockOnAjax(section);
    }

    unblockForAjax() {
        if (!this.complaintForm) return;

        const section = this.complaintForm.closest(
            ".woocommerce-MyAccount-content"
        );

        console.log(section);

        if (!section) return;

        const myBlock = new AjaxBlocking();
        myBlock.unblockOnAjax(section);
    }
}
